//
//
//
//
//
//
//
//
//

import utils from "@/common/util";
import { getCookies, getLocalStorage, setLocalStorage, removeLocalStorage } from "@/common/auth";
export default {
    name: "app",
    provide() {
        return {
            reload: this.reload
        };
    },
    data() {
        return {
            isRouterAlive: true,
            title: ""
        };
    },
    watch: {
        $route: {
            handler: function(route) {
                if (route.path === "/login") {
                    this.$nextTick(() => {
                        utils.setTitle(route.meta.title);
                    });
                } else {
                    this.title = route.meta.title;
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // 通用标签
        getTags() {
            this.$http.common.tags().then(res => {
                setLocalStorage('tags', JSON.stringify(res))
            }).catch(() => {})
        },
        // 获取配置
        getConfig() {
            this.$http.common.configs().then(res => {
                setLocalStorage('telephone', res.service_telephone)
            }).catch(() => {})
        },
        // 获取区域
        getAreas() {
            let params = {}

            this.$http.common.areas(params).then(res => {
                setLocalStorage('areas', JSON.stringify(res))
            }).catch(() => {})
        },
        // 订单筛选项
        getOrdersFilters() {
            let filtersJson = {}
            
            this.$http.orders.ordersFilters().then(res => {
                setLocalStorage('orderFilters', JSON.stringify(res))
                for (const key in res) {
                    if (res.hasOwnProperty(key)) {
                        const element = res[key];
                        filtersJson[key] = {}
                        element.forEach(ele => {
                            filtersJson[key][ele.id] = {
                                id: ele.id,
                                name: ele.name
                            }
                        });
                    }
                }
                setLocalStorage('orderFiltersJson', JSON.stringify(filtersJson))
            }).catch(() => {})
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        }
    },
    mounted() {
        if (!getLocalStorage('tags')) {
            this.getTags()
        }
        if (!getLocalStorage('telephone')) {
            this.getConfig()
        }
        if (!getLocalStorage('areas')) {
            this.getAreas()
        }
        if (!getLocalStorage('orderFilters')) {
            this.getOrdersFilters()
        }
        window.onpopstate = () => {};
    }
};



// WEBPACK FOOTER //
// ./src/App.vue